module.exports = __webpack_public_path__ + "img/textbooks_main_min.d2087118.jpg";